import * as $ from 'jquery';

export class HeaderMenu {

    protected headerMobileSelector = 'select.js-headerMenuMobile';
    protected $headerMenuMobile = $(this.headerMobileSelector);

    constructor() {
        if (this.$headerMenuMobile) {
            this.addMenuChangeWatcher();
        }
        // blur desktop headerMenu
        $(document).on('mousedown', '.hide-on-mobile .headerMenu.select:focus', (event) =>  {
            event.preventDefault();
            $(event.currentTarget).trigger('blur');
        });
    }

    protected addMenuChangeWatcher() {
        $('body').on('change', this.headerMobileSelector, (event) => {
            let $select = $(event.target);
            window.location.href = String($select.val());
        });
    }
}
